// Custom script to change external app search placeholder text
document.addEventListener('DOMContentLoaded', function() {
  // Function to change placeholder text to "Zoeken"
  function changeSearchPlaceholder() {
    // Look for all search input fields with class csh-dropdown-filter
    const searchInputs = document.querySelectorAll('.csh-dropdown-filter');
    
    // Change placeholder text for each found input
    searchInputs.forEach(input => {
      if (input.getAttribute('placeholder') === 'Search') {
        input.setAttribute('placeholder', 'Zoeken');
      }
    });
  }

  // Run immediately
  changeSearchPlaceholder();
  
  // Also run periodically in case the app refreshes its components
  setInterval(changeSearchPlaceholder, 1000);
  
  // Run when DOM changes are detected
  const observer = new MutationObserver(function() {
    changeSearchPlaceholder();
  });
  
  // Start observing
  observer.observe(document.body, { 
    childList: true,
    subtree: true 
  });
});
